import { Component, ReactNode } from 'react'
import * as styles from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020.css'
import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { AnchorPlacement } from 'interfaces/navigation'
import { CardBlock } from 'components/features/pfm/Blocks/Blocks'
import { hasAnchorInsights } from 'helpers/insightHelpers'
import Anchor from 'components/atoms/navigation/Anchor'
import { BlockCorners, QAMarked, ShadowTheme } from 'interfaces/component'
import { blockCornersSelector } from 'selectors/globalSelectors'
import ModuleHeader, { ModuleHeaderProps } from 'components/features/pfm/ModuleWrapper/ModuleHeader'
import * as cn from 'classnames'
import Insights2020 from 'components/features/insights/Insights2020/InsightsContainer2020'
import { createVisibleInsightsByPlacementSelector } from 'selectors/insightsSelectors'

type ModuleWrapperOwnProps = QAMarked & {
  title?: ReactNode
  subtitle?: string
  hint?: ReactNode
  titleLinkTo?: AnchorPlacement
  action?: ReactNode
  anchor?: AnchorPlacement
  card?: boolean
  expand?: boolean
  noPadding?: boolean
  isFlexLayout?: boolean
  isContentFlexLayout?: boolean
  corners?: BlockCorners
  shadowTheme?: ShadowTheme
  nestedModule?: boolean
  forceRoundedCorners?: boolean
  withPaddingBottom?: boolean
  className?: string
  cardClassName?: string
}

type ModuleWrapperStateProps = {
  shouldRenderInsights: boolean
  corners: BlockCorners
}

type ModuleWrapperProps = ModuleWrapperOwnProps & ModuleWrapperStateProps

class ModuleWrapper extends Component<ModuleWrapperProps, {}> {
  static defaultProps: Partial<ModuleWrapperProps> = {
    card: true,
  }

  render () {
    const {
      noPadding,
      withPaddingBottom,
      isFlexLayout,
      qaType,
      qaMarker,
      className,
    } = this.props

    const moduleClasses = cn(styles.moduleWrapper, className, {
      [styles.noPadding]: noPadding,
      [styles.flexLayout]: isFlexLayout,
      [styles.withPaddingBottom]: withPaddingBottom,
    })

    return (
      <div
        className={ moduleClasses }
        data-qa-type={ qaType }
        data-qa-marker={ qaMarker }
      >
        { this.renderChildren() }
      </div>
    )
  }

  renderChildren () {
    const {
      anchor,
      title,
      subtitle,
      action,
      titleLinkTo,
      hint,
      noPadding,
      forceRoundedCorners,
      expand,
      shadowTheme,
      children,
      card,
      isContentFlexLayout,
      cardClassName,
    } = this.props

    const moduleHeaderProps: ModuleHeaderProps = {
      hint,
      title,
      subtitle,
      action,
      titleLinkTo,
      responsive: true,
    }

    const contentChildren = (
      <>
        { this.renderInsights() }
        { children }
      </>
    )

    const contentCard = (
      <>
        <ModuleHeader { ...moduleHeaderProps } />

        { card && (
          <CardBlock
            corners='all'
            isExpanded={ expand }
            withPadding={ !noPadding }
            shadowTheme={ shadowTheme }
            forceRoundedCorners={ forceRoundedCorners }
            className={ cn(cardClassName, {
              [styles.flexLayout]: isContentFlexLayout,
            }) }
          >
            { contentChildren }
          </CardBlock>
        )}
        { !card && contentChildren }
      </>
    )

    return anchor
      ? (
        <Anchor
          placement={ anchor }
          className={ cn({
            [styles.flexLayout]: isContentFlexLayout,
          }) }
        >
          { contentCard }
        </Anchor>
      )
      : contentCard
  }

  renderInsights () {
    const {
      shouldRenderInsights,
      anchor,
    } = this.props

    if (!shouldRenderInsights || !anchor || !hasAnchorInsights(anchor)) {
      return null
    }

    return (
      <div className={ styles.insights }>
        <Insights2020 placement={ anchor } />
      </div>
    )
  }
}

const mapStateToProps = (state: State, ownProps: ModuleWrapperOwnProps): ModuleWrapperStateProps => {
  const { app } = state
  const { anchor, corners } = ownProps

  const insights = anchor ? createVisibleInsightsByPlacementSelector()(state, { placement: anchor as any }) : null
  const hasInsights = !insights ? false :
    insights.some((insight) => !insight.is_dismissed)
  const shouldRenderInsights = hasInsights || app.insights.firstInsightsLoading

  const resultCorners = corners
    ? corners
    : blockCornersSelector(state, ownProps)

  return {
    shouldRenderInsights,
    corners: resultCorners === 'all' && shouldRenderInsights ? 'bottom' : resultCorners,
  }
}

const ModuleWrapper2020 = connect(mapStateToProps)(ModuleWrapper)
export default ModuleWrapper2020
